import { Layers } from 'lucide-react' // Map, Minus, Plus, RotateCcw removed with the Base Map / zoom / reset controls (demo)

interface MapControlClusterProps {
  layerCount: number
  accent: string
  onToggleLayers: () => void
  onToggleBasemap: () => void
  onZoomIn: () => void
  onZoomOut: () => void
  onReset: () => void
}

const BTN =
  'flex h-[38px] cursor-pointer items-center gap-1.5 rounded-[9px] px-[12px] text-[12.5px] font-semibold text-gis-ink-2 hover:bg-[#f3f5f9] hover:text-gis-ink'
// SQ / SEP are used only by the Base Map / zoom / reset controls commented out below (demo):
// const SQ = 'w-[38px] justify-center px-0'
// const SEP = 'mx-[2px] h-[22px] w-px bg-gis-line'

export function MapControlCluster(p: MapControlClusterProps) {
  return (
    <div className="absolute bottom-[18px] right-[18px] z-20 flex items-center gap-[6px] rounded-[14px] bg-gis-card p-[6px] shadow-gis-pop ring-1 ring-[rgba(15,31,61,.06)]">
      <button type="button" onClick={p.onToggleLayers} className={BTN}>
        <Layers className="h-4 w-4" aria-hidden="true" />
        Layers
        <span
          className="rounded-full px-1.5 py-px text-[10px] font-extrabold text-white"
          style={{ background: p.accent }}
        >
          {p.layerCount}
        </span>
      </button>
      {/* Base Map, zoom (+/−) and reset (↺) controls hidden for demo — only Layers remains.
          To restore: re-add the Map / Minus / Plus / RotateCcw icon imports and the SQ / SEP consts
          above, then uncomment this block.
      <button type="button" onClick={p.onToggleBasemap} className={BTN}>
        <Map className="h-4 w-4" aria-hidden="true" />
        Base Map
      </button>
      <span className={SEP} aria-hidden="true" />
      <button type="button" onClick={p.onZoomIn} className={`${BTN} ${SQ}`} aria-label="Zoom in">
        <Plus className="h-4 w-4" aria-hidden="true" />
      </button>
      <button type="button" onClick={p.onZoomOut} className={`${BTN} ${SQ}`} aria-label="Zoom out">
        <Minus className="h-4 w-4" aria-hidden="true" />
      </button>
      <span className={SEP} aria-hidden="true" />
      <button type="button" onClick={p.onReset} className={`${BTN} ${SQ}`} title="Reset view" aria-label="Reset view">
        <RotateCcw className="h-4 w-4" aria-hidden="true" />
      </button>
      */}
    </div>
  )
}
